// React
import Select from "react-select";
import React, { useState, useEffect } from "react";

// Helpers
import { APIClient } from "../../../../helpers/api_helper";

export const SelectSellers = ({ validation }) => {
  const [selectOptions, setSelectOptions] = useState([]);

  const api = new APIClient();

  const getSellersOptions = async () => {
    const findSeller = await api.get("/register/seller");

    if (findSeller) {
      setSelectOptions(
        await findSeller.map((seller) => ({
          value: seller.id,
          label: seller.name,
        }))
      );
    }
  };

  useEffect(() => {
    getSellersOptions();
  }, []);

  return (
    <Select
      isClearable={true}
      value={validation.values.sellerInput}
      onBlur={validation.handleBlur}
      onChange={(e) => {
        const event = {
          target: {
            name: "sellerInput",
            value: e,
          },
        };
        validation.handleChange(event);
      }}
      options={selectOptions || []}
      inputId="sellerInput"
      placeholder="Selecione um vendedor"
      loadingMessage={() => "Carregando..."}
      noOptionsMessage={() => "Sem resultado!"}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};
